import React from 'react'
import PropTypes from 'prop-types'
import { createComponent, withTheme } from '@ycos/fela'

const LiveChatIcon = (props) => {
  const { colour, theme } = props
  const iconColor = theme.typography.colors[`Primary${colour.charAt(0).toUpperCase() + colour.slice(1)}`]

  return (
    <IconContainer>
      <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g id="Icon" transform="translate(0.000000, -0.000000)">
            <polygon id="BoundingBox" points="0 16 16 16 16 1.77635684e-15 0 1.77635684e-15" />
            <path
              d="M1,1 L1,11.001 L4,11.001 L4,15 L7,11.001 L15,11.001 L15,1 L1,1 Z M2,2.001 L14,2.001 L14,10 L6.5,10 L6.2,10.4 L5,12.001 L5,10 L2,10 L2,2.001 Z"
              id="Colour"
              fill={iconColor}
            />
          </g>
        </g>
      </svg>
    </IconContainer>
  )
}

const IconContainer = createComponent(
  'IconContainer',
  () => ({
    width: '16px',
    height: '16px',
  }),
  'div'
)

LiveChatIcon.propTypes = {
  colour: PropTypes.oneOf(['White', 'white', 'Grey', 'grey', 'Black', 'black']),
}

LiveChatIcon.defaultProps = {
  colour: 'White',
}

export default withTheme(LiveChatIcon)
